import React, { CSSProperties, useEffect, useState } from 'react'

import { useCloseFilterSection } from '../../../../core/hooks'
import { FilterSections } from '../../FilterBarTypes'
import { useFilterBar } from '../../providers'

import { Dates } from './Dates/Dates'
import { Guests } from './Guests/Guests'
import { Locations } from './Locations/Locations'
import { Categories } from './Categories/Categories'

import './FilterPanels.css'
import { usePanelPosition } from '../../hooks'

export const FilterPanels = () => {
  const {
    categories,
    calendarRange,
    selectedFilter,
    selectedPath,
    ageCategoryCounts,
    selectedLocations,
    mode,
    tabs,
    disableCalendarDates,
    ageCategories,
    locations,
    language,
    isMobile,
    panelRef,
    buttonRefs,
    filtersRef,
    setSelectedLocations,
    setCalendarRange,
    handleSelectedFilter,
    updateGuestsCount,
    setCategories,
  } = useFilterBar()

  // Handle close filter section
  const { filterSectionRef } = useCloseFilterSection({ handleSelectedFilter })

  const { left, top } = usePanelPosition({
    selectedFilter,
    panelRef,
    filtersRef,
    buttonRefs,
    isMobile,
    tabs,
  })

  const renderContent = () => {
    switch (selectedFilter) {
      case FilterSections.CALENDAR:
        return (
          <Dates
            autoFocus
            ref={filterSectionRef}
            onClose={() => handleSelectedFilter(false)}
            calendarRange={calendarRange}
            setCalendarRange={setCalendarRange}
            disableCalendarDates={disableCalendarDates}
            selectedPath={selectedPath}
            language={language}
          />
        )
      case FilterSections.GUESTS:
        return (
          <Guests
            autoFocus
            ref={filterSectionRef}
            ageCategories={ageCategories}
            ageCategoryCounts={ageCategoryCounts}
            updateGuestsCount={updateGuestsCount}
            onClose={() => handleSelectedFilter(false)}
          />
        )
      case FilterSections.CATEGORIES:
        return (
          <Categories categories={categories} setCategories={setCategories} />
        )
      case FilterSections.LOCATIONS:
        return (
          <Locations
            autoFocus
            ref={filterSectionRef}
            locations={locations?.data}
            selectedLocations={selectedLocations}
            setSelectedLocations={setSelectedLocations}
            multiSelect={locations?.multiSelect}
            onClose={() => handleSelectedFilter(false)}
          />
        )

      default:
        return null
    }
  }

  return (
    selectedFilter && (
      <div
        ref={panelRef}
        className={`will-filter-bar-panels ${mode || 'light'}`}
        style={{ left, top }}
      >
        {renderContent()}
      </div>
    )
  )
}
